import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NotiTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NotiTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.6484 22.5C9.57201 22.5 7.88289 20.8109 7.88289 18.735C7.88289 18.4515 8.11231 18.2221 8.39584 18.2221H14.9009C15.1844 18.2221 15.4138 18.4515 15.4138 18.735C15.4138 20.8109 13.7247 22.5 11.6484 22.5ZM8.95687 19.248C9.19781 20.5143 10.3129 21.4741 11.6484 21.4741C12.9838 21.4741 14.0989 20.5143 14.3398 19.248H8.95687Z"
        fill="#696969"
      />
      <path
        d="M18.074 9.94327C20.0613 9.94327 21.6724 8.33221 21.6724 6.34487C21.6724 4.35752 20.0613 2.74646 18.074 2.74646C16.0867 2.74646 14.4756 4.35752 14.4756 6.34487C14.4756 8.33221 16.0867 9.94327 18.074 9.94327Z"
        fill="#FC3B26"
      />
      <path
        d="M19.8139 10.9764C19.4962 11.0959 19.1639 11.1794 18.8191 11.2318L19.9948 16.7874C20.0665 17.1271 19.9823 17.4767 19.7639 17.7462C19.5455 18.0157 19.2214 18.17 18.8748 18.17H4.75162C4.40498 18.17 4.08038 18.0157 3.86198 17.7462C3.64357 17.4757 3.55942 17.1271 3.63155 16.7874L5.32518 8.78463C5.96988 5.73799 8.69843 3.5259 11.8132 3.5259C12.5044 3.5259 13.1707 3.65063 13.8054 3.85351C13.9901 3.53768 14.2019 3.24212 14.4496 2.97576C13.6214 2.66882 12.7323 2.5 11.8132 2.5C8.21653 2.5 5.0657 5.05373 4.32133 8.57224L2.6277 16.575C2.49145 17.2182 2.65074 17.8805 3.06501 18.3914C3.47927 18.9024 4.09391 19.1959 4.75162 19.1959H18.8748C19.532 19.1959 20.1466 18.9034 20.5609 18.3924C20.9751 17.8815 21.1344 17.2192 20.9987 16.5751L19.8139 10.9764Z"
        fill="#696969"
      />
    </svg>
  );
};

export default NotiTrueIcon;
